import { createContext, useContext } from "react";
import { i18n } from "../data/i18n.js";

export const LangCtx = createContext("en");
export const useTr = () => i18n[useContext(LangCtx)];
